import { CardContainer, useScreenWidth } from "@msys/ui";
import { Box, Container } from "@mui/material";
import React, { FC } from "react";
import { Page } from "../../commons/layout/Page.js";
import { PageColumn } from "../../commons/layout/PageColumn.js";
import { PageContainer } from "../../commons/layout/PageContainer.js";

export const ExampleLayoutBothSidebarsPreview: FC = () => {
  const { isMinDesktop } = useScreenWidth();
  return (
    <Page>
      <PageColumn $hasBackground $hasRightBorder>
        <CardContainer title="Tree">
          <Box
            sx={{
              height: 2000,
            }}
          />
        </CardContainer>
      </PageColumn>
      {isMinDesktop && (
        <PageContainer>
          <Container maxWidth="md">
            <CardContainer title="Preview">
              <Box
                sx={{
                  height: 2000,
                }}
              />
            </CardContainer>
          </Container>
        </PageContainer>
      )}
      <PageColumn $hasBackground $hasLeftBorder={isMinDesktop}>
        <CardContainer title="Settings">
          <Box
            sx={{
              height: 200,
            }}
          />
        </CardContainer>
        <CardContainer title="Summary">
          <Box
            sx={{
              height: 400,
            }}
          />
        </CardContainer>
        <CardContainer title="Settings">
          <Box
            sx={{
              height: 300,
            }}
          />
        </CardContainer>
      </PageColumn>
    </Page>
  );
};
